// @ts-ignore
import {Link} from "react-router-dom";
import React from "react";
import {Avatar, Button, CircularProgress, Sheet, Stack, Typography, useColorScheme} from "@mui/joy";
import {motion} from "framer-motion";
function LoadingPage(): React.ReactElement {
    const {mode, setMode} = useColorScheme();
    return (
        <Sheet>
            <Stack
                height='100vh'
                direction="column"
                spacing={4}
                alignItems={{md: "center", xs: "center"}}
                justifyContent={{lg: "center", xs: "center"}}
                paddingX={5}
            >
                <Stack direction='row' alignItems='center'>
                    <Typography color='primary' fontWeight='lg'>FUMA</Typography>
                    <Typography sx={{color: mode === 'dark' ? 'white' : 'black'}} fontWeight='lg'>VIPEMAN</Typography>
                </Stack>
                <motion.div
                    initial={{opacity: 0.1}}
                    animate={{
                        opacity: 1,
                    }}
                    transition={{repeat: Infinity, duration: 3}}
                >
                    <Typography level='body-md' sx={{color: mode === 'dark' ? 'white' : 'black'}} fontWeight='lg'>Loading</Typography>
                </motion.div>
                <CircularProgress determinate={false}/>
            </Stack>
        </Sheet>
    );
}
export default LoadingPage;